import type { SecondaryOrderStatePath } from 'state/secondaryMarket/secondaryMarket.model';
import type { FormType } from 'state/secondaryMarket/shared/form/form.model';
import type { AppState } from 'state/state.model';

export const formSelectorsFactory = <S>(
  stateType: Exclude<SecondaryOrderStatePath, 'cpOrder'>,
  formType: FormType,
  selectors: S,
) => {
  const select = (state: AppState, tabId: string) => state.secondaryMarket[stateType].form[formType][tabId];
  return {
    getFormClient: (state: AppState, tabId: string) => select(state, tabId)?.client,
    getFormClientType: (state: AppState, tabId: string) => select(state, tabId)?.clientType,
    getFormSettlementDate: (state: AppState, tabId: string) => select(state, tabId)?.settlementDate,
    getFormCustodianBdrId: (state: AppState, tabId: string) => select(state, tabId)?.custodian?.id,
    getFormCustodian: (state: AppState, tabId: string) => select(state, tabId)?.custodian,
    getFormTradeWay: (state: AppState, tabId: string) => select(state, tabId)?.tradeWay,
    getFormSalesId: (state: AppState, tabId: string) => select(state, tabId)?.salesId,
    getFormSalesDesk: (state: AppState, tabId: string) => select(state, tabId)?.salesDesk,
    getFormSettlementType: (state: AppState, tabId: string) => select(state, tabId)?.settlementType,
    getFormCashAmount: (state: AppState, tabId: string) => select(state, tabId)?.cashAmount,
    getFormTradeSizeInputMode: (state: AppState, tabId: string) => select(state, tabId)?.tradeSizeInputMode,
    getFormQuantity: (state: AppState, tabId: string) => select(state, tabId)?.quantity,
    getFormComment: (state: AppState, tabId: string) => select(state, tabId)?.comment,
    getFormSalesMargin: (state: AppState, tabId: string) => select(state, tabId)?.salesMargin,
    ...selectors,
  };
};
